module.exports = __webpack_public_path__ + "static/img/image_application2.467b7f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page3/image_application2.png
// module id = JdG2
// module chunks = 1